/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Missing_Permissions_DescriptionInputs */

const en_toast_missing_permissions_description = /** @type {(inputs: Toast_Missing_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to access this resource or perform this action`)
};

const nl_toast_missing_permissions_description = /** @type {(inputs: Toast_Missing_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U heeft geen toestemming om deze bron te openen of deze actie uit te voeren.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to access this resource or perform this action" |
*
* @param {Toast_Missing_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_missing_permissions_description = /** @type {((inputs?: Toast_Missing_Permissions_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Missing_Permissions_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_missing_permissions_description(inputs)
	return en_toast_missing_permissions_description(inputs)
});